<template>
  <div class="schoolclubs-box">
    <div class="schoolclubs-title">
      <div class="schoolclubs-title1">School Clubs</div>
      <div class="schoolclubs-title2">Recommend the school club for you</div>
    </div>
    <div class="course-list-box_">
      <div class="course-list-box list-container">
        <div class="course-item" v-for="(item, index) in clubList" :key="index">
          <div class="course-item-content" @click.stop="goToClubDetail(item)">
            <div class="avatar">
              <el-image :src="item.covey_user ? item.covey_user.groupImg : ''">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="course-item-describe-img">
              <img :src="item.covey_user ? item.covey_user.photo : ''" />
            </div>
            <div class="course-item-describe-info">
              <div class="describe-name">
                {{ item.societyName }}
              </div>
              <div class="describe-content">
                {{ item.maincontent }}
              </div>
            </div>
            <div class="describe-groupinfo">
              <div class="describe-groupinfo-left">
                <div>Followers:&nbsp;{{ item.covey_user.studentnums }}</div>
                <div>
                  Last event:&nbsp;{{ item.covey_user.lasttime | lastTime }}
                </div>
              </div>

              <div class="describe-groupinfo-right">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="
                    item.guser ||
                    (item.guser && userInfo && item.guser === userInfo.id)
                      ? 'Joined'
                      : 'Join club'
                  "
                  placement="bottom-start"
                  ><i
                    class="fa fa-heart"
                    :class="{
                      isJioned:
                        item.guser ||
                        (item.guser && userInfo && item.guser === userInfo.id),
                    }"
                    @click.stop="
                      () =>
                        item.guser ||
                        (item.guser && userInfo && item.guser === userInfo.id)
                          ? cancelgroup(item.id)
                          : joinClub(item.id)
                    "
                  ></i
                ></el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="course-list-box list-container max-width-box">
        <div class="course-item" v-for="(item, index) in clubList" :key="index">
          <div class="course-item-content">
            <div class="avatar" @click.stop="goToClubDetail(item.id)">
              <img :src="item.covey_user ? item.covey_user.groupImg : ''" />
            </div>

            <div class="course-item-describe-info">
              <img :src="item.covey_user ? item.covey_user.photo : ''" />
              <div class="describe-name" @click.stop="goToClubDetail(item.id)">
                {{ item.societyName }}
              </div>
            </div>
            <div class="describe-type">{{ item.maincontent }}</div>
            <div class="describe-groupinfo">
              <div>Followers:{{ item.covey_user.studentnums }}</div>
              <div v-if="item.covey_user.lasttime">
                Last event:{{ item.covey_user.lasttime | lastTime }}
              </div>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Join Club"
                  placement="bottom-start"
                  ><i
                    class="fa fa-heart"
                    :class="{
                      isJioned:
                        item.guser ||
                        (item.guser && userInfo && item.guser === userInfo.id),
                    }"
                    @click="joinClub(item.id)"
                  ></i
                ></el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div v-if="isMore" class="view-more">
      <el-button @click.stop="loadMore">VIEW MORE CLUBS</el-button>
    </div>
  </div>
</template>

<script>
import SearchTop from "@/views/Pc/Component/SearchTop";
import RecommendCourses from "@/views/Pc/Component/RecommendCourses";
import CourseInfo from "@/views/Pc/Component/CourseInfo";
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
      schoolId: (state) => state.app.schoolId,
    }),
  },
  data() {
    return {
      clubList: [],
      pageParams: {
        page: 1,
        limit: 12,
      },
      isMore: false,
    };
  },
  components: {
    RecommendCourses,
    SearchTop,
    CourseInfo,
  },
  watch: {
    "$route.query": function (newVal, oldVal) {
      this.initPage();
    },
    schoolId: function (newVal, oldVal) {
      this.pageParams.page = 1;
      this.resetData();
      this.getClubList();
    },
  },
  filters: {
    lastTime(val) {
      if (!val) {
        return "comming soon";
      } else {
        let t1 = moment(val);
        let t2 = moment();
        let diffDay = t1.diff(t2, "days");
        if (diffDay === 0) {
          return "Today";
        } else if (diffDay > 0) {
          return Math.abs(diffDay) + " days later";
        } else {
          return Math.abs(diffDay) + " days ago";
        }
      }
    },
  },
  created() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.getClubList();
      //如果url内有courseId进来，去课程详情页面
    },
    resetData() {
      this.clubList = [];
      this.isMore = true;
      this.pageParams = {
        page: 1,
        limit: 12,
      };
    },
    async getClubList() {
      let clubRes = {};
      let params = { ...this.pageParams };
      if (this.schoolId) {
        params["schoolId"] = this.schoolId;
      }
      if (!this.userInfo.login_name) {
        clubRes = await this.$api.courseApi.getClubList(params);
      } else {
        clubRes = await this.$api.courseApi.getLoginedGroupList(params);
      }
      //是否更多
      if (clubRes.status === "0") {
        this.isMore =
          this.pageParams.page <
          Math.ceil(clubRes.data.count / this.pageParams.limit);
        this.clubList = clubRes.data.rows;
        // if (
        //   this.pageParams.page <=
        //   Math.ceil(clubRes.data.count / this.pageParams.limit)
        // ) {
        //   this.isMore = true;
        //   this.pageParams.page++;
        //   for (let item of clubRes.data.rows) {
        //     this.clubList.push(item);
        //   }
        // } else {
        //   this.isMore = false;
        // }
      }
    },
    async loadMore() {
      if (this.isMore) {
        this.pageParams.page++;
        let clubRes = {};
        let params = { ...this.pageParams };
        if (this.schoolId) {
          params["schoolId"] = this.schoolId;
        }
        if (!this.userInfo.login_name) {
          clubRes = await this.$api.courseApi.getClubList(params);
        } else {
          clubRes = await this.$api.courseApi.getLoginedGroupList(params);
        }
        //是否更多
        if (clubRes.status === "0") {
          this.clubList = this.clubList.concat(clubRes.data.rows);
          this.isMore =
            this.pageParams.page <
            Math.ceil(clubRes.data.count / this.pageParams.limit);
        }
      }
    },
    async joinClub(id) {
      this.$confirm("Are you sure to join?", {}).then(async () => {
        const { status, message } = await this.$api.courseApi.joinGroup({
          groupId: id,
        });
        if (status === "0") {
          this.$message({
            type: "success",
            message: message,
          });
          this.pageParams.page = 1;
          this.getClubList();
        } else {
          this.$message({
            type: "warning",
            message: message,
          });
        }
      });
    },
    //退出社团
    async cancelgroup(id) {
      this.$confirm("Are you sure to cancel?", {}).then(async () => {
        const { status, message } = await this.$api.courseApi.cancelgroup({
          groupId: id,
        });
        if (status === "0") {
          this.$message({
            type: "success",
            message: message,
          });
          this.pageParams.page = 1;
          this.getClubList();
        } else {
          this.$message({
            type: "warning",
            message: message,
          });
        }
      });
    },
    goToClubDetail(item) {
      let guser = item.guser ? item.guser : -1;
      this.$router.push(
        "/page/clubdetail?groupId=" + item.id + "&guser=" + guser
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
$navColor: #fff;

// @media only screen and (min-width: 1600px) {
//   .schoolclubs-box {
//     .course-list-box {
//       grid-template-columns: repeat(3, 1fr);
//       grid-gap: 32px;
//     }
//   }
// }
.schoolclubs-box {
  // background: #f0f2f5;
  .schoolclubs-title {
    margin-bottom: 20px;
    .schoolclubs-title1 {
      height: vh(60);
      font-size: vh(24);
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #181d2c;
      line-height: vh(60);
      text-align: center;
    }
    .schoolclubs-title2 {
      height: vh(25);
      font-size: vh(18);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7e8088;
      line-height: vh(25);
      text-align: center;
    }
  }
  .course-list-box_ {
    padding: 0 32px 64px 32px;
    max-width: 1088px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  // padding: 0 120px;
  // box-sizing: border-box;
  .list-container {
    display: grid;
    grid-gap: 32px;
  }

  .course-list-box {
    // width: vw(1408);
    // max-width: 1400px;
    box-sizing: border-box;
    margin: 0 auto;
    // display: grid;
    grid-template-columns: repeat(3, 1fr);
    // grid-gap: 20px 20px;
    .course-item {
      // width: vw(352);
      // height: vh(370);
      box-sizing: border-box;
    }
    .course-item-content {
      width: 100%;
      // height: 100%;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      cursor: pointer;
      .avatar {
        // position: relative;
        // width: 100%;
        // height: vh(180);
        // img {
        //   width: 320px;
        //   height: 192px;
        //   border-radius: 8px;
        // }
        .el-image {
          width: 320px;
          height: 192px;
          border-radius: 8px;
          .el-icon-picture-outline {
            font-size: 30px;
          }
        }
      }

      box-sizing: border-box;
      .course-item-describe-img {
        width: 100%;
        height: 34px;
        box-sizing: border-box;
        padding: 0 24px;
        position: relative;
        img {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          position: absolute;
          top: -34px;
        }
      }
      .course-item-describe-info {
        width: 100%;
        padding: 16px 24px;
        box-sizing: border-box;
        font-family: PingFangSC-Medium, PingFang SC;
        .describe-name {
          font-size: 16px;
          font-weight: 500;
          color: #181d2c;
          height: 20px;
          line-height: 20px;
          margin-bottom: 10px;
          display: -webkit-box;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-line-clamp: 1; /*要显示的行数*/
          -webkit-box-orient: vertical;
        }
        .describe-content {
          font-size: 14px;
          color: #7e8088;
          font-weight: 500;
          line-height: 20px;
          display: -webkit-box;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-line-clamp: 2; /*要显示的行数*/
          -webkit-box-orient: vertical;
        }
      }

      // .describe-type {
      //   cursor: pointer;
      //   color: #222325;
      //   line-height: 22px;
      //   // font-weight: 400;
      //   height: 44px;
      //   -webkit-box-sizing: border-box;
      //   box-sizing: border-box;
      //   overflow: hidden;
      //   padding: 0 12px 5px;
      //   margin: 5px 0;
      //   word-wrap: break-word;
      //   word-break: break-word;
      //   -webkit-transition: 0.15s ease-in-out;
      //   -o-transition: 0.15s ease-in-out;
      //   transition: 0.15s ease-in-out;
      //   display: block;
      //   display: -webkit-box;
      //   -webkit-line-clamp: 2;
      //   -webkit-box-orient: vertical;
      // }
      .describe-groupinfo {
        display: flex;
        height: 80px;
        border-top: 1px solid #efeff0;
        box-sizing: border-box;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 16px 24px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
        .describe-groupinfo-left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .describe-groupinfo-right {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .isJioned {
          color: #f48c06 !important;
        }
        .fa-heart {
          color: #b5b6ba;
          &:hover {
            color: #f48c06;
          }
        }
      }
    }
  }
  // .course-list-box {
  //   // width: vw(1408);
  //   // max-width: 1400px;
  //   box-sizing: border-box;
  //   margin: 0 auto;
  //   // display: grid;
  //   // // grid-template-columns: repeat(5, 1fr);
  //   // grid-gap: 20px 20px;
  //   .course-item {
  //     // width: vw(352);
  //     // height: vh(370);
  //     box-sizing: border-box;
  //   }
  //   .course-item-content {
  //     width: 100%;
  //     // height: 100%;
  //     box-sizing: border-box;
  //     background: #fff;
  //     // border-radius: 8px;
  //     box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  //     cursor: pointer;
  //     .avatar {
  //       position: relative;
  //       width: 100%;
  //       height: vh(180);
  //       img {
  //         width: 100%;
  //         height: 100%;
  //       }
  //     }

  //     box-sizing: border-box;
  //     .course-item-describe-info {
  //       line-height: 120%;
  //       -webkit-box-sizing: border-box;
  //       box-sizing: border-box;
  //       padding: 12px 12px 8px;
  //       height: 54px;
  //       width: 100%;
  //       display: flex;
  //       flex-direction: row;
  //       justify-content: flex-start;
  //       align-items: center;
  //       img {
  //         width: 24px;
  //         height: 24px;
  //         border-radius: 50%;
  //       }
  //       .describe-name {
  //         font-size: 14px;
  //         font-weight: 600;
  //         color: #181d2c;
  //         width: calc(100% - 24px);
  //         height: 18px;
  //         padding-left: 8px;
  //         -o-text-overflow: ellipsis;
  //         text-overflow: ellipsis;
  //         overflow: hidden;
  //         white-space: nowrap;
  //         overflow: hidden;
  //         &:hover {
  //           text-decoration: underline;
  //         }
  //       }
  //     }
  //     .describe-type {
  //       cursor: pointer;
  //       color: #222325;
  //       line-height: 22px;
  //       // font-weight: 400;
  //       height: 44px;
  //       -webkit-box-sizing: border-box;
  //       box-sizing: border-box;
  //       overflow: hidden;
  //       padding: 0 12px 5px;
  //       margin: 5px 0;
  //       word-wrap: break-word;
  //       word-break: break-word;
  //       -webkit-transition: 0.15s ease-in-out;
  //       -o-transition: 0.15s ease-in-out;
  //       transition: 0.15s ease-in-out;
  //       display: block;
  //       display: -webkit-box;
  //       -webkit-line-clamp: 2;
  //       -webkit-box-orient: vertical;
  //     }
  //     .describe-groupinfo {
  //       border-top: 1px solid #efeff0;
  //       display: flex;
  //       -webkit-box-pack: justify;
  //       -ms-flex-pack: justify;
  //       justify-content: space-between;
  //       padding: 10px 12px;
  //       font-size: 12px;
  //       .isJioned {
  //         color: #f48c06 !important;
  //       }
  //       .fa-heart {
  //         color: #b5b6ba;
  //         &:hover {
  //           color: #f48c06;
  //         }
  //       }
  //     }
  //   }
  // }
  .view-more {
    margin: 40px 0 0 0;
    padding: 0 0 96px 0;
    text-align: center;
    .el-button {
      width: 312px;
      height: 48px;
      background: #f48c06;
      border-radius: 32px;
      color: #ffffff;
      font-weight: 600;
      font-size: 20px;
      border: none;
    }
  }
}
</style>
